import Cookies from 'js-cookie';

import { JWT_COOKIE_NAME } from '@/configuration/client';
import { sendMessageUp } from '@/helpers/iframeMessages';
import isBrowser from '@/helpers/isBrowser';
import { logError } from '@/providers/ErrorTracking';

import { type AuthUser } from './constants';
import decodeToken from './decodeToken';

function getCookieUser(): AuthUser | null {
  const jwtCookie = Cookies.get(JWT_COOKIE_NAME);
  try {
    if (jwtCookie) {
      return decodeToken(jwtCookie);
    }
  } catch (error) {
    logError(error);
  }
  if (!isBrowser()) {
    return null;
  }

  sendMessageUp({
    message: 'get-client-cookie',
  });

  return null;
}

export default getCookieUser;
